<template>
  <div class="home-container">
    <div class="home-content">
      <!-- 搜索 -->
      <div></div>
      <div style="margin: 20px 0">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        row-key="id"
        border
        lazy
        :load="load"
        :default-expand-all="false"
        :tree-props="{ children: 'list', hasChildren: 'hasChildren' }"
        v-if="isShowRouter"
      >
        <el-table-column prop="id" align="center" label="分类id" width="100">
        </el-table-column>
        <el-table-column prop="name" align="center" label="分类名称">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >
            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog
        :title="visibleTitle"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <el-form
          :model="addData"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="选择上级分类" prop="parentId">
            <el-select clearable filterable v-model="addData.parentId" placeholder="请选择上级">
              <el-option
                v-for="(item, ind) in tableData"
                :key="ind"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类名称" prop="name">
            <el-input
              v-model="addData.name"
              placeholder="请输入分类名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="des">
            <el-input
              v-model="addData.des"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit('ruleForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sortSum: 0,
      tableData: [],
      visibleTitle: "新增",
      dialogVisible: false,
      sortVisible: false,
      isShowRouter:true,
      addData: {
        id:'',
        parentId: "",
        name: "",
        des:''
      },
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    // 懒加载
    load(tree, treeNode, resolve) {
      let page = {
        current: 1,
        size: 100,
        type:1,
        parentId: tree.id,
      };
      this.$Apis.orderWorkCategoryList(page).then((res) => {
        if (res.code == 200) {
          resolve(res.data.list)
        }
      });
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        current: this.currentPage,
        size: this.pageSize,
        type:1
      };
      this.tableData = [];
      this.$Apis.orderWorkCategoryList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          res.data.list.forEach((item) => {
            item.list = [];
            item.hasChildren = true;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
          this.dialogVisible = false;
        }
      });
    },
    // 删除
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除此项", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isShowRouter = false
          this.$Apis.orderWorkCategoryDel({ id: id }).then((res) => {
            if (res.code == 200) {
              this.isShowRouter = true
              this.$message.success("删除成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch((err) => {});
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    // 修改
    updataCharacter(row) {
      row.parentId = row.parentId == "" ? "" : row.parentId;
      this.addData = JSON.parse(JSON.stringify(row));
      this.visibleTitle = "修改";
      this.dialogVisible = true;
    },
    // 新增
    addCharacter() {
      this.addData.name = "";
      this.addData.parentId = "";
      this.addData.des = "";
      this.visibleTitle = "新增";
      this.dialogVisible = true;
    },
    // 提交
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = {
            id: this.addData.id || "",
            name: this.addData.name,
            parentId: this.addData.parentId || "",
            des:this.addData.des,
            type:1
          };
          this.btnLoading = true;
          this.$Apis.orderWorkCategoryAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script> 

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px 25px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>